import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAlerts, upsertAlert } from '@rapid-recovery-agency-inc/insightt-shared';

import { InsighttNotification } from '../../../helpers/insightt-notification';
import { GET_NOTIFICATION_PREFERENCES, SET_ALERT_MEDIUM, UPSERT_ALERT } from './types';
import { client } from '../../../shared/apollo';

export const getNotificationSettings = createAsyncThunk(
  GET_NOTIFICATION_PREFERENCES,
  async ({ userId, fetchPolicy }, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { alertsMap } = await fetchAlerts(client, { userId, fetchPolicy });
      return fulfillWithValue({ alertsMap });
    } catch (err) {
      InsighttNotification('error', 'Error getting preferences', err);
      return rejectWithValue(err);
    }
  },
);

export const setAlertMedium = createAction(SET_ALERT_MEDIUM);

export const upsertAlertAction = createAsyncThunk(
  UPSERT_ALERT,
  async ({ userId, type, medium, enabled }, { fulfillWithValue, rejectWithValue, dispatch }) => {
    dispatch(setAlertMedium({ type, medium, enabled }));

    try {
      const { data } = await upsertAlert(client, {
        userId,
        type,
        method: medium,
        enabled,
      });
      dispatch(getNotificationSettings({ userId, fetchPolicy: 'network-only' }));
      return fulfillWithValue({ data });
    } catch (error) {
      dispatch(setAlertMedium({ type, medium, enabled: !enabled }));
      InsighttNotification('error', 'Error updating preferences', error);
      return rejectWithValue(error);
    }
  },
);
